export { default } from './Sistarbanc';
